/**
 * Applicant progress is the canonical, seven-stage worker completion snapshot.
 * Do not substitute staff-file UCE, recruitment verification, or the legacy
 * onboarding wizard's approval-owned percentage when this snapshot is missing.
 */
export function resolveApplicantProfileProgress(onboardingSync) {
  const progress = onboardingSync?.applicant_progress;
  if (!progress || typeof progress !== 'object') return null;

  // Number(null) === 0, so missing fields must be rejected BEFORE conversion.
  if (progress.total_steps == null || progress.completed_steps == null || progress.percentage == null) return null;

  const total = Number(progress.total_steps);
  const completed = Number(progress.completed_steps);
  const percentage = Number(progress.percentage);
  if (!Number.isInteger(total) || total <= 0 ||
      !Number.isInteger(completed) || completed < 0 || completed > total ||
      !Number.isFinite(percentage) || percentage < 0 || percentage > 100) return null;

  // The backend intentionally caps some all-finished-but-unresolved journeys at
  // 99%. In every other case, a percent grossly inconsistent with its own step
  // counts is stale/untrustworthy and must not be displayed as a real value.
  const countedPercentage = Math.floor((completed / total) * 100);
  const pendingActionCap = completed === total && percentage === 99;
  if (!pendingActionCap && Math.abs(percentage - countedPercentage) > 1) return null;

  return {
    source: 'applicant_progress_onboarding_wizard',
    completed,
    total,
    percentage: Math.round(percentage),
  };
}
